export type HeadlineLevel = 1 | 2 | 3 | 4 | 5
export type TextLevel = 1 | 2 | 3 | 4 | 5 | 6

export const HEADLINE_CLASS_BY_LEVEL = {
  1: 'text-[64px] leading-[76px]',
  2: 'text-4xl leading-[44px]', // 36px
  3: 'text-2xl leading-9',
  4: 'text-base leading-normal',
  5: 'text-xs leading-normal tracking-[0.8px]',
} as const satisfies Record<HeadlineLevel, string>

export const TEXT_CLASS_BY_LEVEL = {
  1: 'text-[18px] leading-[28px]',
  2: 'text-base leading-normal', // 16px
  3: 'text-sm leading-normal', // 14px
  4: 'text-xs leading-normal', // 12px
  5: 'text-[11px] leading-normal',
  6: 'text-[8px] leading-normal',
} as const satisfies Record<TextLevel, string>
